import { useQuery } from "@tanstack/react-query";
import { api } from "@utils/api";
import i18n from "src/i18n";

export interface PrimarySpecialization {
  _id: string;
  slug: string;
  labels: { en: string; fr: string };
  active: boolean;
  profile_count?: number;
  draft_count?: number;
}

export const primarySpecializationsKey = ["primary-specializations"];

export const usePrimarySpecializations = (admin = false) =>
  useQuery<PrimarySpecialization[]>({
    queryKey: [...primarySpecializationsKey, admin],
    queryFn: async () => (await api.get(`primary-specializations${admin ? "/admin" : ""}`)).data,
  });

export const primarySpecializationOptions = (entries: PrimarySpecialization[] = []) =>
  entries.filter(entry => entry.active).map(entry => ({
    value: entry._id,
    label: entry.labels[i18n.language.startsWith("fr") ? "fr" : "en"],
  })).sort((a, b) => a.label.localeCompare(b.label));
